import type { LucideIcon } from 'lucide-react';

interface PlaceholderCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

/**
 * A soft, muted card shown in place of an action card when a student has no
 * data for it (no upcoming class, nothing due). Keeps the action column's
 * structure intact instead of collapsing to empty space.
 */
export function PlaceholderCard({ icon: Icon, title, description }: PlaceholderCardProps) {
  return (
    <section className="rounded-xl border border-dashed border-border bg-muted/30 p-4">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground">
          <Icon className="h-4 w-4" />
        </span>
        <div>
          <p className="font-heading text-sm font-semibold text-foreground">{title}</p>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
      </div>
    </section>
  );
}
